const { axios } = require("@cores/axiosWrapper");
import fp from "lodash/fp";
import { createAction, handleActions } from "redux-actions";
import {
    addSharedUsersOfAssetAPI,
    changeSharedUsersOfAssetAPI,
    deleteResourceGranteesAPI,
    deleteSharedUsersOfAssetAPI,
    getMySharedAssetsAPI,
    getMySharingAssetsAPI,
    getSharedUsersOfAssetAPI,
} from "./apis/shared-box-v2";
import { withAbortHandling } from "@hooks/useAbortController";

const initialState = {
    pending: false,
    data: null,
    error: null,
    sharedUsersOfAsset: {
        pending: false,
        data: null,
        error: null,
    },
};

const cloneInitialState = fp.cloneDeep(initialState);

const GET_MY_SHARED_ASSETS_LIST_PENDING = "GET_MY_SHARED_ASSETS_LIST_PENDING";
const GET_MY_SHARED_ASSETS_LIST_SUCCESS = "GET_MY_SHARED_ASSETS_LIST_SUCCESS";
const GET_MY_SHARED_ASSETS_LIST_FAILURE = "GET_MY_SHARED_ASSETS_LIST_FAILURE";
const RESET_MY_SHARED_ASSETS_LIST = "RESET_MY_SHARED_ASSETS_LIST";
const GET_SHARED_USERS_OF_ASSET_PENDING = "GET_SHARED_USERS_OF_ASSET_PENDING";
const GET_SHARED_USERS_OF_ASSET_SUCCESS = "GET_SHARED_USERS_OF_ASSET_SUCCESS";
const GET_SHARED_USERS_OF_ASSET_FAILURE = "GET_SHARED_USERS_OF_ASSET_FAILURE";
const INCREASE_MY_SHARED_ASSETS_DOWNLOAD_COUNT = "INCREASE_MY_SHARED_ASSETS_DOWNLOAD_COUNT";
// const UPDATE_SHARED_USERS_OF_ASSET_PENDING = "UPDATE_SHARED_USERS_OF_ASSET_PENDING";
// const UPDATE_SHARED_USERS_OF_ASSET_SUCCESS = "UPDATE_SHARED_USERS_OF_ASSET_SUCCESS";
// const UPDATE_SHARED_USERS_OF_ASSET_FAILURE = "UPDATE_SHARED_USERS_OF_ASSET_FAILURE";

export default handleActions(
    {
        [GET_MY_SHARED_ASSETS_LIST_PENDING]: (state) => {
            return {
                ...state,
                pending: true,
            };
        },
        [GET_MY_SHARED_ASSETS_LIST_SUCCESS]: (state, action) => {
            return {
                ...state,
                pending: false,
                data: action.payload,
            };
        },
        [GET_MY_SHARED_ASSETS_LIST_FAILURE]: (state, action) => {
            return {
                ...state,
                pending: false,
                error: action.payload,
            };
        },
        [RESET_MY_SHARED_ASSETS_LIST]: (state) => {
            return cloneInitialState;
        },
        [GET_SHARED_USERS_OF_ASSET_PENDING]: (state, action) => {
            return {
                ...state,
                sharedUsersOfAsset: {
                    ...state.sharedUsersOfAsset,
                    pending: true,
                    data: action.payload,
                },
            };
        },
        [GET_SHARED_USERS_OF_ASSET_SUCCESS]: (state, action) => {
            return {
                ...state,
                sharedUsersOfAsset: {
                    ...state.sharedUsersOfAsset,
                    pending: false,
                    data: action.payload,
                },
            };
        },
        [GET_SHARED_USERS_OF_ASSET_FAILURE]: (state, action) => {
            return {
                ...state,
                sharedUsersOfAsset: {
                    ...state.sharedUsersOfAsset,
                    pending: false,
                    error: action.payload,
                },
            };
        },
        [INCREASE_MY_SHARED_ASSETS_DOWNLOAD_COUNT]: (state, action) => {
            const { payload: downloaded } = action;

            return {
                ...state,
                data: state?.data?.map((item) => {
                    if (downloaded.id === item.id && item.option?.maxDownloads) {
                        return {
                            ...item,
                            option: {
                                ...item.option,
                                downloadCount: (item.option?.downloadCount ?? 0) + 1,
                            },
                        };
                    }
                    return item;
                }),
            };
        },
    },
    initialState,
);

export const resetMySharedAssetsList = createAction(RESET_MY_SHARED_ASSETS_LIST);
export const increaseMySharedAssetsDownloadCount = createAction(INCREASE_MY_SHARED_ASSETS_DOWNLOAD_COUNT);

export const getMySharedAssets = (params, signal) => async (dispatch, getState) => {
    const { stage } = getState();
    const { endpoint } = stage;

    try {
        dispatch({
            type: GET_MY_SHARED_ASSETS_LIST_PENDING,
        });

        const result = await withAbortHandling(
            getMySharedAssetsAPI(endpoint, params, signal),
            "공유 자산 목록 요청이 취소되었습니다",
        );

        if (result.canceled) return result;

        if (result.success) {
            dispatch({
                type: GET_MY_SHARED_ASSETS_LIST_SUCCESS,
                payload: result.data.data?.results,
            });
        }

        return result.data.data;
    } catch (error) {
        dispatch({
            type: GET_MY_SHARED_ASSETS_LIST_FAILURE,
            payload: error,
        });
        return error;
    }
};

export const getMySharingAssets = (params, signal) => async (dispatch, getState) => {
    const { stage } = getState();
    const { endpoint } = stage;

    try {
        dispatch({
            type: GET_MY_SHARED_ASSETS_LIST_PENDING,
        });

        const result = await withAbortHandling(
            getMySharingAssetsAPI(endpoint, params, signal),
            "공유 자산 목록 요청이 취소되었습니다",
        );

        if (result.canceled) return result;

        if (result.success) {
            dispatch({
                type: GET_MY_SHARED_ASSETS_LIST_SUCCESS,
                payload: result.data.data?.results,
            });
        }

        return result.data.data;
    } catch (error) {
        dispatch({
            type: GET_MY_SHARED_ASSETS_LIST_FAILURE,
            payload: error,
        });
        return error;
    }
};

export const getSharedUsersOfAsset = (id, projectId, params) => async (dispatch, getState) => {
    try {
        const { stage } = getState();

        let results = [];
        let nextToken = null;

        dispatch({ type: GET_SHARED_USERS_OF_ASSET_PENDING });
        do {
            const response = await getSharedUsersOfAssetAPI(stage.endpoint, stage.id, projectId, id, params, nextToken);
            results = results.concat(response.data.results);
            nextToken = response.data.nextToken;
        } while (!!nextToken);

        dispatch({ type: GET_SHARED_USERS_OF_ASSET_SUCCESS, payload: results });
        return results;
    } catch (e) {
        console.log(e);
        dispatch({ type: GET_SHARED_USERS_OF_ASSET_FAILURE, payload: e });
    }
};

export const deleteSharedUsersOfAsset =
    ({ assetId, projectId, shareId, customErrorMessage }) =>
    (dispatch, getState) => {
        const { stage, project } = getState();

        return new Promise((resolve, reject) => {
            deleteSharedUsersOfAssetAPI(
                stage.endpoint,
                stage.id,
                projectId ?? project.id,
                assetId,
                shareId,
                customErrorMessage,
            )
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

export const changeSharedUsersOfAsset =
    ({ assetId, projectId, data, customErrorMessage }) =>
    (dispatch, getState) => {
        const { stage, project } = getState();
        const { shareId, ...rest } = data;
        return new Promise((resolve, reject) => {
            changeSharedUsersOfAssetAPI(
                stage.endpoint,
                stage.id,
                projectId ?? project.id,
                assetId,
                shareId,
                rest,
                customErrorMessage,
            )
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

export const addSharedUsersOfAsset =
    ({ assetId, projectId, data, customErrorMessage }) =>
    (dispatch, getState) => {
        const { stage, project } = getState();

        return new Promise((resolve, reject) => {
            addSharedUsersOfAssetAPI(
                stage.endpoint,
                stage.id,
                projectId ?? project.id,
                assetId,
                data,
                customErrorMessage,
            )
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };
